/**
 * Enumeration of pressure units.
 *
 * @readonly
 * @enum {string}
 */

export const PressureUnits = Object.freeze({
    BAR: 'bar',
    PSI: 'psi'
})
